import React from 'react'

const ICON = {
    width: "30",
    height: "30",
    color: "#FB6B6B"
};


const IconLogout = () => {
    return(     
    <svg width={ICON.width} height={ICON.height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="15" fill="white"/>
        <path d="M21.75 15C21.75 18.722 18.722 21.75 15 21.75C11.278 21.75 8.25 18.722 8.25 15C8.25 12.5151 9.5967 10.3265 11.6244 9.15351C11.9883 8.94305 12.454 9.06733 12.6645 9.4313C12.8751 9.79527 12.7507 10.2609 12.3868 10.4715C10.7743 11.4042 9.7726 13.1395 9.7726 15C9.7726 17.8824 12.1176 20.2274 15 20.2274C17.8825 20.2274 20.2274 17.8824 20.2274 15C20.2274 13.1395 19.2257 11.4042 17.6132 10.4714C17.2493 10.2609 17.1249 9.79515 17.3355 9.43126C17.546 9.06726 18.0117 8.9429 18.3756 9.15351C20.4019 10.3257 21.75 12.5134 21.75 15ZM14.2387 15V9.01126C14.2387 8.59081 14.5795 8.24998 15 8.24998C15.4205 8.24998 15.7613 8.59081 15.7613 9.01126V15C15.7613 15.4204 15.4205 15.7613 15 15.7613C14.5795 15.7613 14.2387 15.4204 14.2387 15Z" fill={ICON.color}/>
    </svg>
    )
}

export default IconLogout;